import styled from 'styled-components';

export const ControlSection = styled.section`
  width: 100%;
  padding: 16px 0;
`;

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
`;

export const ToggleLabel = styled.span`
  font-size: 16px;
  line-height: 1.5;
  color: ${({ theme }) => theme?.a11y?.textPrimaryOnLight || '#262626'};
`;

export const StatusHint = styled.p`
  margin: 0 0 24px;
  color: ${({ theme }) => theme?.a11y?.textOnLight || '#595959'};
  font-size: 14px;
  line-height: 1.5;
`;
